import Cookies from 'js-cookie';

import { getRootDomain } from 'utilities';

export const CLIENT_ID_COOKIE = 'es_client_id';
export const CLIENT_SUBDOMAIN_COOKIE = 'es_client_subdomain';
export const USER_EMAIL_COOKIE = 'es_user_email_address';
export const USER_AUTH_TYPE_COOKIE = 'es_user_auth_type';
export const CONNECTION_CTA_COOKIE = 'es_connection_cta';
export const PUSH_NOTIFICATION_COOKIE = 'es_push_notification';

export const USER_AUTH_COOKIE_DAYS = 3;
export const WELCOME_COOKIE_DAYS = 30;
export const DEFAULT_COOKIE_DAYS = 365;
export const PUSH_NOTIFICATION_DAYS = 7;

const getSetterOptions = (days = DEFAULT_COOKIE_DAYS) => {
  const domain = getRootDomain();
  const options = { expires: days, domain: `.${domain}`, secure: true };
  (options as any).SameSite = 'None';
  return options;
};

export default {
  set clientSubdomain(subdomain: string) {
    Cookies.set(CLIENT_SUBDOMAIN_COOKIE, subdomain, getSetterOptions());
  },
  set userEmail(email: string) {
    Cookies.set(USER_EMAIL_COOKIE, email, getSetterOptions());
  },
  set connectionCta(value: string) {
    Cookies.set(CONNECTION_CTA_COOKIE, value, getSetterOptions(WELCOME_COOKIE_DAYS));
  },
  set pushNotification(value: string) {
    Cookies.set(PUSH_NOTIFICATION_COOKIE, value, getSetterOptions(PUSH_NOTIFICATION_DAYS));
  },
  get clientSubdomain() {
    return Cookies.get(CLIENT_SUBDOMAIN_COOKIE);
  },
  get userEmail() {
    return Cookies.get(USER_EMAIL_COOKIE);
  },
  get connectionCta() {
    return Cookies.get(CONNECTION_CTA_COOKIE);
  },
  get pushNotification() {
    return Cookies.get(PUSH_NOTIFICATION_COOKIE);
  },
  removeAll() {
    const domain = getRootDomain();
    const options = { domain: `.${domain}` };

    /**
     * USER_AUTH_TYPE_COOKIE intentionally not removed
     * Leaving it allows auth only users a better logout
     * experience
     */
    Cookies.remove(CLIENT_ID_COOKIE, options);
    Cookies.remove(CLIENT_SUBDOMAIN_COOKIE, options);
    Cookies.remove(USER_EMAIL_COOKIE, options);
    Cookies.remove(CONNECTION_CTA_COOKIE, options);
    Cookies.remove(PUSH_NOTIFICATION_COOKIE, options);
  },
};

// DEV-1117 - initially clients will have a bunch of trash cookies left over which need to be deleted
// This can be deleted after a week or so
function migrateAmplifyToLocalStorage() {
  const cookieKeys = document.cookie.split(';').map(cookie => cookie.split('=')[0].trim());
  cookieKeys.forEach(key => {
    if (key.match(/CognitoIdentityServiceProvider/)) {
      Cookies.remove(key, getSetterOptions());
    }
  });
}
migrateAmplifyToLocalStorage();
